import { Mediator } from "mediator-js";

import { AnalyticsEvent } from "@services/tracking/types/analyticsEvent";

import { deepCopy } from "../util/DeepCopy";
import WindowManagement, { WindowKeys } from "../util/WindowManagement";
import { Subscriber } from "./Subscriber";
import { SubscriberCallback } from "./SubscriberCallback";

const NAMESPACE_TRACKING = "tracking";
const NAMESPACE_HISTORY = "tracking_history";

class EventDataLayer {
    private mediator: any;
    private trackingHistory: AnalyticsEvent[];

    public trackingSubscribers: Subscriber[];

    constructor() {
        this.trackingSubscribers = [];
        this.trackingHistory = [];
        this.mediator = new Mediator();
    }

    public static getInstance(): EventDataLayer {
        if (!WindowManagement.getObject(WindowKeys.TRACKER)) {
            WindowManagement.saveObject(
                WindowKeys.TRACKER,
                new EventDataLayer(),
            );
        }
        return WindowManagement.getObject(WindowKeys.TRACKER);
    }

    public subscribe(
        subscriberName: string,
        callback: SubscriberCallback,
        withHistory: boolean = false,
    ): boolean {
        if (subscriberName && typeof callback === "function") {
            this.trackingSubscribers.push({
                name: subscriberName,
                subscriber: this.mediator.subscribe(
                    NAMESPACE_TRACKING,
                    callback,
                ),
            });

            if (withHistory) {
                this.runHistory(callback);
            }

            return true;
        }

        return false;
    }

    public track(event: AnalyticsEvent) {
        const trackingEvent = deepCopy(event);
        this.mediator.publish(
            NAMESPACE_TRACKING,
            trackingEvent.event,
            trackingEvent,
        );
        this.trackingHistory.push(trackingEvent);
    }

    private runHistory(callback: SubscriberCallback) {
        if (this.trackingHistory.length > 0) {
            // send history only for specific subscriber
            const predicate = (eventName: string, data: any, id: string) =>
                id === subscriber.id;
            const subscriber = this.mediator.subscribe(
                NAMESPACE_HISTORY,
                callback,
                { predicate },
            );

            this.trackingHistory.forEach(item => {
                this.mediator.publish(
                    NAMESPACE_HISTORY,
                    item.event,
                    item,
                    subscriber.id,
                );
            });

            this.mediator.remove(NAMESPACE_HISTORY, subscriber.id);
        }
    }
}

export default EventDataLayer;
